module.exports = __webpack_public_path__ + "static/media/image012.53901125.jpg";